import { render, staticRenderFns } from "./Agencias.vue?vue&type=template&id=81b60d7e&scoped=true&"
import script from "./Agencias.vue?vue&type=script&lang=js&"
export * from "./Agencias.vue?vue&type=script&lang=js&"
import style0 from "./Agencias.vue?vue&type=style&index=0&id=81b60d7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b60d7e",
  null
  
)

export default component.exports